import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SITE_LINKS } from '../site-links';

@Component({
    selector: 'app-mcp-guide',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './mcp-guide.component.html',
    styleUrls: ['./mcp-guide.component.css']
})
export class McpGuideComponent {
    readonly links = SITE_LINKS;
}
